import {EnvConfig} from "@/config/app.config"

// TODO: REPLACE WITH NEW VALUES WHEN CREATED IN AAD
export const envConfig: EnvConfig = {
    OIDC_AUTHORITY: "https://login.microsoftonline.com/4c867488-2d0b-43ff-9829-1aa2d7ae43b5/v2.0",
    OIDC_CLIENT_ID: "ade3108a-df36-448f-88ae-62b78136a52f",
    OIDC_SCOPES: "openid profile api://ade3108a-df36-448f-88ae-62b78136a52f/stores",
    TARGET_ENVIRONMENT: "PROD",
    API: {
        SPCI_BASE_URL: "https://us-central1-coop-plu.cloudfunctions.net/v1/spci/",
    },
    TRACKING: {
        LOG_ROCKET_APP_ID: "bs42ff/coop-self-checkout-spci",
    },
}
